import apiRequest from './index'

export default {
  path: '/v1/carwash/gmo/linkTypePlus/cardEdit',

  async post (authid) {
    await window.callNativeHTTPX()
    return apiRequest.post(this.path, {}, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
        'APP-USERS-AUTH-ID': authid
      }
    })
  }
}
